<template>
  <div class="container">
    <div class="padding-10">
      <h1 class="text-align-center">Units</h1>
      <p class="text-align-justify">
        Lorem ipsum dolor sit amet consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
        deserunt mollit anim id est laborum.
      </p>


      <DivLinkButton v-bind="{routeName: 'Units'}">
        <div class="heading">For a complete list of all units and more detailed info about each unit click here.</div>
      </DivLinkButton>
    </div>

  </div>
</template>

<script>
import DivLinkButton from "../basic_comp/DivLinkButton"

export default {
  name: "Units",
    components: {
    DivLinkButton,
  },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/info/Units.vue